import { getFlow } from './utils'

export type ValidationParent = {
  customValidityMessage: string
} & HTMLElement

export default function updateValidationUI(
  self,
  message: string,
  parent: ValidationParent,
  target: HTMLObjectElement
) {
  parent.customValidityMessage = message
  if (getFlow(self).disable_form_validation) {
    /* If no validity message, or watching for validity updates, then create and update the ui. */
    if (!message || parent.getAttribute('show-validity-message') === 'true') {
      setValidationMessage(parent, message)
    }
  } else {
    if (target && typeof target.setCustomValidity === 'function') {
      target.setCustomValidity(message)
    }
  }
}

export function setValidationMessage(parentEl: HTMLElement, message: string) {
  const targetElement = parentEl
  const containers = targetElement.querySelectorAll('.validation-failed')

  if (!message) {
    targetElement.setAttribute('show-validity-message', 'false')
    containers.forEach((el) => el.remove())
    return
  }

  if (containers.length > 0) {
    containers.forEach((el) => {
      if (el instanceof HTMLElement) {
        el.innerText = message
      }
    })
  } else {
    const validationContainer = document.createElement('div')
    validationContainer.classList.add('validation-failed')
    validationContainer.setAttribute('data-controller', 'template')
    validationContainer.setAttribute('data-template-watch-contents-value', 'true')
    validationContainer.setAttribute('data-template-always-rerender-value', 'true')
    validationContainer.innerText = message
    targetElement.appendChild(validationContainer)
  }
}

export function reportValidation(target: HTMLObjectElement) {
  if (target && typeof target.reportValidity === 'function') {
    // I need to set a flag to prevent infinite loops
    if (target.getAttribute('reporting-validity') === 'true') {
      target.setAttribute('reporting-validity', 'false')
      return
    }
    target.setAttribute('reporting-validity', 'true')
    target.reportValidity()
  }
}
